import { Component, HostListener, Inject, Injectable, OnInit ,Pipe,ViewChild} from '@angular/core';
import { HomeService } from '../_services/home.service';
import { environment } from '../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {NgbModal,NgbModalConfig,} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { DOCUMENT } from '@angular/common';
import '../../assets/myjs/svchatplugin.js'; 

import { AuthenticationService } from '../_services';
declare var $ :any;
// @Pipe({ name: 'safeHtml'})
@Injectable({
    providedIn:'root'
})
@Component({
selector: 'app-chat-user-interface',
templateUrl: './chat-user-interface.component.html',
styleUrls: ['./chat-user-interface.component.scss'],
providers: [NgbModalConfig, NgbModal]
})
export class ChatUserInterfaceComponent implements OnInit {

@ViewChild('content') content;
active=false
chatform:FormGroup
topic:string
time:any
queueTest:string
message:string
chat:boolean=false
chatOn:string
queues:any=Array
listQueues:string[ ]=[ ]
config: NgbModalConfig;
privacyStatement:any
plainText:any
showChat: boolean=false;
name:string
chatQueuesSize: any[ ]=[ ];
chatRedirectURL: any;
chatObj: any;
chatOffStrategy: any;
isChatOfficeTime: any;
selectChatQueue: any;
chatQueues: any;
topicContent: string;
i18n: any;
user: any;
queseId: any;
isSmartViewChat: any;
oneComponent: string;
chatBox: string;
shpLogin:String;
    
constructor(private homeService: HomeService,
private activatedRoute: ActivatedRoute,private router: Router,@Inject(DOCUMENT) private document:Document,private formBuilder: FormBuilder,private modalService: NgbModal,private spinner: NgxSpinnerService, private authService: AuthenticationService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
} 
@HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key === "Escape") {
        let exdays = -1;
        var d = new Date();  
		d.setTime(d.getTime() + (exdays*24*60*60*1000));  
		let expires = "expires="+d.toUTCString();  
        document.cookie = "isOpened" + "=" + '' + "; " + expires + "; path=/";
        this.close();
    }
}
ngOnInit() {
console.log("chat user Interface");
this.homeService.endChat.subscribe(res => {
    if (res) {
        this.close();
    }
});
this.homeService.getChatOfficeTime().subscribe(res=>{
 this.isChatOfficeTime=res.return_body.chatOfficeTime;
})
if (sessionStorage.getItem('i18n')) {
    this.i18n = JSON.parse(sessionStorage.getItem('i18n'));
}
this.chatform = this.formBuilder.group(
{
topic: ['', [Validators.required]],
queueTest:['', [Validators.required]],
})
}
ngAfterViewInit() {
this.chatBox=sessionStorage.getItem('chatBox');
this.spinner.show();
setTimeout(() => {
this.spinner.hide();

this.homeService.getShpLogin().subscribe(res=>{
this.isSmartViewChat=res.return_body.is_smart_view_chat
this.topic=res.return_body.chatTopicPrompt
this.queueTest=res.return_body.queueSelectionText
})
if(this.authService.getCurrentUserPK()!=null){
this.homeService.getContact().subscribe(res=>{
 this.user= {
    user_pk: res.return_body.id,
    user_name:res.return_body.user_name,
    first_name: res.return_body.first_name,
    last_name: res.return_body.last_name,
    email: res.return_body.email,
    phone_number: res.return_body.primary_phone	
};
});
}else{
    this.homeService.getDefaultUser().subscribe(res=>{
        this.user=res.return_body; 
    })
}
this.homeService.getPrivacyStatement().subscribe(res=>{
this.privacyStatement=res.return_body.html_content
this.plainText=this.privacyStatement
})
this.homeService.getChat().subscribe(res=>{
this.queues=res.return_body 
for(var val of this.queues){
this.chatQueuesSize.push(val)
this.listQueues.push(val.external_name)
}
})
console.log(this.chatQueuesSize)
this.homeService.getChatOfficeTime().subscribe(res=>{
this.homeService.getMessage().subscribe(ress=>{
    this.message =ress.return_body.chatMessage
this.homeService.getShpLogin().subscribe(login=>{
    let currentUser = JSON.parse(this.authService.getCurrentUser());
    if(login.return_body.isSHPLogin === true && (currentUser === null || currentUser.user === null)){
        // localStorage.setItem("isChatOn","no");
        this.authService.setValueInConfigAtLocalStorage('isChatOn', 'no');
        this.homeService.closeChat.next(true);
        // localStorage.setItem("autoOpenChatWindow","yes");
        this.authService.setValueInConfigAtLocalStorage('autoOpenChatWindow', 'yes');
        /* unset showCreateCaseModal value */
        if (this.authService.getValueInConfigFromLocalStorage('showCreateCaseModal') === 'yes') {
            this.authService.setValueInConfigAtLocalStorage('showCreateCaseModal', 'no');
        }
        // this.router.navigate([this.router.url.split("/")[1], 'login']); 
        this.homeService.navigateToLogin(this.router.url);
    }
    else {  
        this.message =ress.return_body.chatMessage
        this.chatOffStrategy=res.return_body.chatOffStrategy
        this.chatRedirectURL =ress.return_body.chatRedirectURL
        if (res.return_body.chatOfficeTime===true) {
            if(this.chatBox==null){
                console.log(this.chat)
                this.openModal();
                // localStorage.setItem("autoOpenChatWindow","no");
                this.authService.setValueInConfigAtLocalStorage('autoOpenChatWindow', 'no');
            }
            else{
                this.chatPopUp()
            }
        } else{
            this.chatPopUp();
        } 
    }
    })})})
    }, 500);
    }
openModal() {
const modal = this.modalService.open(this.content);
modal. result.then(() => { console.log('When user closes'); }, () => { this.closeModal()})
}
chatPopUp(){
    var hourChatMessage=this.message
    var time=this.isChatOfficeTime
    // if(this.isChatOfficeTime===true){
        sessionStorage.removeItem('isOffHours');
    sessionStorage.setItem("chatBox","true");
    if (sessionStorage.getItem('i18n')) {
        this.i18n = JSON.parse(sessionStorage.getItem('i18n'));
    }
    var chatObj;
    if(this.chatQueuesSize.length>=2){
    for(var val of this.queues)
        {
            if(val.external_name==this.queues.external_name){
                this.queseId=val.queueId
            }
        }
    }else{
        for(var value of this.chatQueuesSize){
        if(value.active=true){
        this.queseId=value.queueId
        }
    }}
        var content=sessionStorage.getItem('topicContent')
        var queue=sessionStorage.getItem('queueId')
        var insShortName= this.homeService.instshortname;
        var topicContent=this.topicContent;
        var queueId=this.queseId;
        var caller=this.user;
        var chatBox= this.chatBox	   
        try {
            $(document).ready(function () {
                var chat = $(".svButton").svChat(
                    {
                        inst_short_name: insShortName,
                        i18n: this.i18n,
                        chatServerUrl:environment.chatServerUrl
                    }
                );
            if(time===true){
                if(chatBox!="true") {
                chatObj = chat;
                chat.setCaller(caller);
                chat.setQueue(queueId);
                chat.setTopicContent(topicContent);
                }
                else{
                chatObj = chat;
                chat.setCaller(caller);
                chat.setQueue(queue);
                chat.setTopicContent(content);
                }
            }else{
                chatObj=chat
                    sessionStorage.setItem('isOffHours',"true");
                	sessionStorage.setItem('hourChatMessage',hourChatMessage);
                	chat.showChat();
            }
            });
        
        } catch (err) {
            console.log(err);
        }
   this.closeModal()
}
close(){
    sessionStorage.removeItem("chatBox");
    sessionStorage.removeItem('refreshPage');
    // this.authService.setChatOn("no");
    this.authService.setValueInConfigAtLocalStorage('isChatOn', 'no');
    this.modalService.dismissAll('Cross click');
    this.homeService.closeChat.next(true);
}
closeModal() {
    this.modalService.dismissAll('Cross click')
    }

    checkLogin() {
        let currentUser = JSON.parse(this.authService.getCurrentUser());
        if (currentUser === null || currentUser.user === null) {
            this.homeService.navigateToLogin(this.router.url);
        }
    }
}

